import { getLastNumber } from 'src/utils/numberUtils';
import { ReportOrderServiceLevels } from 'src/report/pdf/report-components';

export const isLevel3Report = (order): boolean => {
    if (order.serviceLevel.report === ReportOrderServiceLevels.level3) {
        return true;
    }
    if (order.serviceLevel.report === ReportOrderServiceLevels.threeYearPlan) {
        return (getLastNumber(order.serviceLevel.name) === 3);
    }
    return false;
};



// WEBPACK FOOTER //
// ./src/order/utils.tsx